import React from "react";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {Link} from 'react-router-dom';


const PrintingScanningAndPhotocopying = () =>{
  
  return (
    <div className="LearningSpace">
      <section className="inner-banner banner-align">
        <img className="img-fluid" src="./assets/img/innerbanner/explore.jpg" alt="" />
      </section>
      <section className='information-common' id="ExploreLibrary">
        <div className='container'>
          <div className='information-content'>
            <h2>Explore Library</h2>
            <p>The following collaborative spaces are available at the library.</p>
          </div>
          <Row>
                <Col lg={5} sm={6}>
                <div className="floating-Side-wrap">
                    <div className="floating-Side">
                        <div className="right-tab-collab">
                        <div className="flex-column nav nav-pills">
                                <div className="nav-item">
                                    <Link as={Link} to="/CollaborativeWorkingAndLearningSpaces" className='nav-link'>
                                    Collaborative Working and Learning Spaces
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/ComputerAndTechnology" className='nav-link'>
                                    Computer And Technology
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/PrintingScanningAndPhotocopying" className='nav-link active'>
                                    Printing Scanning And Photocopying
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/LibraryServices" className='nav-link'>
                                    Library Services
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/MakerSpace" className='nav-link '>
                                    Maker Space
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </Col>
                <Col lg={7} sm={6}>
                <div className="collaboration-hover">
                    <img className="img-fluid" src="./assets/img/learningspaces/printing-space.png" alt="" />
                    {/* <p>Both floors are equipped with high-speed network Do It Yourself (DIY) printers with photocopying and scanning services. Printing and photocopying can be done by purchasing a scratch card from Habib Dukaan and using your student ID or employee ID card.</p> */}
                    <p>Both floors are equipped with high-speed network Do It Yourself (DIY) printers with photocopying and scanning services.</p>

                    <p>HU community may request color printing, binding, or scanning of relevant and important documents, marketing materials, etc., through this service. A nominal fee is charged for color printing.</p>
                </div>
                </Col>
            </Row>
        </div>
      </section>


    </div>
  );
}
export default PrintingScanningAndPhotocopying;